export enum ESearchType {
  input = 'input',
  selection = 'selection',
  date = 'date',
  dateRange = 'dateRange',
}

// ä¸å¡å±çº§
export enum EBizLevel {
  Acquirer = 'institution',
  Institution = 'institution',
  Group = 'agent',
  Agent = 'agent',
  Merchant = 'merchant',
  Store = 'store',
  Terminal = 'terminal',
  User = 'user',
}

// æ¥è¡¨ç¶æ
export enum EReportStatus {
  Normal = 'normal', // æ­£å¸¸ç¶æ
  Disabled = 'disabled', // åç¨ç¶æ
}

// æ¥è¡¨ç±»å
export enum EReportType {
  Standard = 0, // æ åæ¥è¡¨
  Custom = 1, // å®å¶æ¥è¡¨
  SelfDefined = 2, // èªå®ä¹æ¥è¡¨
}

// é¨åºç¶æ
export enum EStoreStatus {
  Normal = 'Normal',
  Deleted = 'Deleted',
  Test = 'Test',
}

// æ¯ä»åç
export enum EPaymentBrand {
  Alipay = 'ALP',
  WeChat = 'WXP',
  WeChatHK = 'WHK',
  Grab = 'GRB',
  TrueMoney = 'TRU',
  NTT = 'DOT',
  TIS = 'TIS',
  UPI = 'UPI',
  Visa = 'VIS',
  MasterCard = 'MCC',
  FPS = 'FPS',
  AME = 'AME',
  Adyen = 'Adyen',
  Stripe = 'Stripe',
  Empty = '',
}

export enum ECardTradeChannel {
  'VIS' = 'PAYMENT_BRAND.VIS',
  'MCC' = 'PAYMENT_BRAND.MCC',
  'AME' = 'PAYMENT_BRAND.AME',
}

// äº¤ææ¸ éï¼åæ¯ä»åçæ¯ç¸åçå³ç³»
export enum ETradeChannel {
  'ALP' = 'PAYMENT_BRAND.ALP',
  'WXP' = 'PAYMENT_BRAND.WXP',
  'FPS' = 'PAYMENT_BRAND.FPS',
  'MCC' = 'PAYMENT_BRAND.MCC',
  'TRU' = 'PAYMENT_BRAND.TRU',
  'UPI' = 'PAYMENT_BRAND.UPI',
  'VIS' = 'PAYMENT_BRAND.VIS',
  'AME' = 'PAYMENT_BRAND.AME',
  // 'GRB' = 'PAYMENT_BRAND.GRB',
  // 'WHK' = 'PAYMENT_BRAND.WHK',
  // 'DOT' = 'PAYMENT_BRAND.DOT',
  // 'TIS' = 'PAYMENT_BRAND.TIS',
  // 'Adyen' = 'PAYMENT_BRAND.ADYEN',
  // 'Stripe' = 'PAYMENT_BRAND.STRIPE',
}

// äº¤æåºæ¯
export enum ETransScene {
  /** ç  */
  'api-complete' = 'TRANS_SCENE.api-complete',
  'api-freeze' = 'TRANS_SCENE.api-freeze',
  'api-pay' = 'TRANS_SCENE.api-pay',
  'api-refund' = 'TRANS_SCENE.api-refund',
  'api-scan' = 'TRANS_SCENE.api-scan',
  'api-transport' = 'TRANS_SCENE.api-transport',
  'api-unfreeze' = 'TRANS_SCENE.api-unfreeze',
  'appp' = 'TRANS_SCENE.appp',
  'doco-pay' = 'TRANS_SCENE.doco-pay',
  'doco-refund' = 'TRANS_SCENE.doco-refund',
  'doco-scan' = 'TRANS_SCENE.doco-scan',
  'mini-program-pay' = 'TRANS_SCENE.mini-program-pay',
  'mis-pay' = 'TRANS_SCENE.mis-pay',
  'mis-refund' = 'TRANS_SCENE.mis-refund',
  'mis-scan' = 'TRANS_SCENE.mis-scan',
  'others' = 'TRANS_SCENE.others',
  'pc-pay' = 'TRANS_SCENE.pc-pay',
  'pos-complete' = 'TRANS_SCENE.pos-complete',
  'pos-freeze' = 'TRANS_SCENE.pos-freeze',
  'pos-unfreeze' = 'TRANS_SCENE.pos-unfreeze',
  'qr-pay' = 'TRANS_SCENE.qr-pay',
  'term-complete' = 'TRANS_SCENE.term-complete',
  'term-freeze' = 'TRANS_SCENE.term-freeze',
  'term-pay' = 'TRANS_SCENE.term-pay',
  'term-refund' = 'TRANS_SCENE.term-refund',
  'term-scan' = 'TRANS_SCENE.term-scan',
  'term-unfreeze' = 'TRANS_SCENE.term-unfreeze',
  'web-chan-refund' = 'TRANS_SCENE.web-chan-refund',
  'web-pay' = 'TRANS_SCENE.web-pay',
  'web-refund' = 'TRANS_SCENE.web-refund',
  'web-scan' = 'TRANS_SCENE.web-scan',

  /** å¡ */
  'card-others' = 'TRANS_SCENE.card-others',
  'card-web-refund' = 'TRANS_SCENE.card-web-refund',
  'pos-BLD' = 'TRANS_SCENE.pos-BLD',
  'pos-PER' = 'TRANS_SCENE.pos-PER',
  'pos-PVR' = 'TRANS_SCENE.pos-PVR',
  'pos-CTH' = 'TRANS_SCENE.pos-CTH',
  'pos-PPA' = 'TRANS_SCENE.pos-PPA',
  'pos-PNP' = 'TRANS_SCENE.pos-PNP',
  'pos-ACR' = 'TRANS_SCENE.pos-ACR',
  'pos-PCR' = 'TRANS_SCENE.pos-PCR',
  'pos-CVR' = 'TRANS_SCENE.pos-CVR',
  'pos-CJT' = 'TRANS_SCENE.pos-CJT',
  'pos-ADJ' = 'TRANS_SCENE.pos-ADJ',
  'pos-OPE' = 'TRANS_SCENE.pos-OPE',
  'openapi-PER' = 'TRANS_SCENE.openapi-PER',
  'openapi-PVR' = 'TRANS_SCENE.openapi-PVR',
  'openapi-CTH' = 'TRANS_SCENE.openapi-CTH',
  'openapi-PPA' = 'TRANS_SCENE.openapi-PPA',
  'openapi-PNP' = 'TRANS_SCENE.openapi-PNP',
  'openapi-ACR' = 'TRANS_SCENE.openapi-ACR',
  'openapi-PCR' = 'TRANS_SCENE.openapi-PCR',
  'openapi-CVR' = 'TRANS_SCENE.openapi-CVR',
  'openapi-CJT' = 'TRANS_SCENE.openapi-CJT',
  'openapi-ADJ' = 'TRANS_SCENE.openapi-ADJ',
  'openapi-OPE' = 'TRANS_SCENE.openapi-OPE',

  // 'pt-refund' = 'è¿ç¹éè´§',
  // 'canc' = 'åæ¶',
  // 'freeze' = 'é¢ææå»ç»',
  // 'unfreeze' = 'é¢ææè§£å»',
  // 'auth-complete' = 'é¢ææå®æ',
}

// äº¤æç¶æ
export const TransProc = {
  7: 'æªç¥7',
  6: 'æªç¥6',
  5: 'å¤çä¸­',
  2: 'å¤±è´¥',
  0: 'æå',
}

// äº¤æç¶æå½éå
export const TransProcI18n = {
  7: 'TRANS_PROC.UNKNOWN_7',
  6: 'TRANS_PROC.UNKNOWN_6',
  5: 'TRANS_PROC.PENDING',
  2: 'TRANS_PROC.REJECT',
  0: 'TRANS_PROC.RESOLVE',
}

// ç¨æ·ç±»å
export enum EUserType {
  CIL = 'admin', // è¶çº§ç®¡çå
  GenAdmin = 'genAdmin', // æ®éç®¡çå
  Institution = 'institution', // æºæç¨æ·
  Agent = 'agent', // éå¢ç¨æ·
  Merchant = 'merchant', // åæ·ç¨æ·
  Store = 'store', // é¨åºç¨æ·
}

// ç¨æ·ç±»åç¿»è¯å­æ®µå¯¹åº
export enum EUserTypeI18n {
  CIL = 'USERTYPE.ADMIN', // è¶çº§ç®¡çå
  GenAdmin = 'USERTYPE.GENADMIN', // æ®éç®¡çå
  Institution = 'USERTYPE.INSTITUTION', // æºæç¨æ·
  Agent = 'USERTYPE.AGENT', // éå¢ç¨æ·
  Merchant = 'USERTYPE.MERCHANT', // åæ·ç¨æ·
  Store = 'USERTYPE.STORE', // é¨åºç¨æ·
}

// æ±æ»ç»´åº¦ç¿»è¯å­æ®µå¯¹åº
export enum ELevelI18n {
  Institution = 'GENERAL.BIZ_LEVEL.INSTITUTION', // æºæ
  Agent = 'GENERAL.BIZ_LEVEL.AGENT', // éå¢
  Merchant = 'GENERAL.BIZ_LEVEL.MERCHANT', // åæ·
  Store = 'GENERAL.BIZ_LEVEL.STORE', // é¨åº
}

export enum EUserStatus {
  Normal = 'normal',
  Freeze = 'freeze',
}

export enum EStatus {
  Normal = 'normal',
  Freeze = 'freeze',
}

// æ¥è¡¨ç¶æ
export enum EColumnType {
  Date = 'date', // æ¥æ
  Address = 'address',
  Select = 'select',
  Checkbox = 'checkbox',
  Radio = 'radio',
  Switch = 'switch',
}

export enum ERoleType {
  Admin = 1, // ç®¡çåè§è²ç±»å
  Acquirer = 2, // æºæè§è²ç±»å
  Group = 3, // éå¢è§è²ç±»å
  Merchant = 4, // åæ·è§è²ç±»å
  Store = 5, // é¨åºè§è²ç±»å
}

// 1-èåï¼2-å¬å±èåï¼3-åè½ï¼4-åç»å½ï¼5-åéªè¯, 6-æ å°èå
export enum EMenuType {
  Menu = 1,
  CommonMenu = 2,
  Function = 3,
  Public = 4,
  Protect = 5,
  Mapping = 6,
}

export enum ETabScrollStatus {
  InitialLoad = 1,
  Stop = 2,
  Scroll = 3,
}

/** èªå®ä¹ ACL æ§å¶ */
export enum ECustomAcl {
  ReleaseDetailDate = 'cil.custom.release.date',
  AuditStore = 'cil.custom.audit.store',
  StoreEditable = 'cil.custom.store.editable',
  ChargeDebitAndRepresent = 'cil.custom.charge.debitAndRepresent',
  AcquirerSupportDualMessage = 'cil.custom.acquirer.supportDualMessage',
  TerminalPANCanUPI = 'cil.custom.terminal.pan.upi',
  TerminalPANCanVIS = 'cil.custom.terminal.pan.vis',
  TerminalPANCanMCC = 'cil.custom.terminal.pan.mcc',
  TerminalPANCanFPS = 'cil.custom.terminal.pan.fps',
}
